
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { KioskFormPhoneField } from './KioskFormPhoneField/KioskFormPhoneField';
import { FormPhoneFieldProps } from './FormPhoneField.types';
import { WebFormPhoneField } from './WebFormPhoneField/WebFormPhoneField';

const FormPhoneField = ({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.NumberPad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    initiallyMasked = false,
    onChangeCallback,
    tabFocusRefContext,
    noValidation = false,
}: FormPhoneFieldProps) => {
    return isElectron() ? (
        <KioskFormPhoneField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            initiallyMasked={initiallyMasked}
            onChangeCallback={onChangeCallback}
            noValidation={noValidation}
        />
    ) : (
        <WebFormPhoneField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            initiallyMasked={initiallyMasked}
            onChangeCallback={onChangeCallback}
            noValidation={noValidation}
        />
    );
};

export default FormPhoneField;
